<div [ngClass]="background" class="kpi-page">
  <div class="kpi-container">
    <div class="kpibox">
      <div class="kpi-info" *ngIf="data && data.First">
        <div class="kpi-title">{{ data.First.Name }}</div>
        <div class="kpi-number">
          <ng-container *ngIf="type === 'number'">
            {{ data.First.Value | number }}
          </ng-container>
          <ng-container *ngIf="type === 'time'">
            {{ data.First.Value }}
          </ng-container>
          <ng-container *ngIf="type !== 'number' && type !== 'time'">
            {{ data.First.Value }}
          </ng-container>
        </div>
      </div>
      <div class="icon" *ngIf="icon"><i class="{{ icon }} kpi-icon"></i></div>
    </div>
    <footer class="kpifooter" *ngIf="data && data.Second">
      <div class="kpi-sub-title">
        <small>{{ data.Second.Name }}</small>
      </div>
      <div fxFlex></div>
      <div class="kpi-sub-number">
        <small>
          <ng-container *ngIf="type === 'number'">
            {{ data.Second.Value | number }}
          </ng-container>
          <ng-container *ngIf="type === 'time'">
            {{ data.Second.Value }}
          </ng-container>
          <ng-container *ngIf="type !== 'number' && type !== 'time'">
            {{ data.Second.Value }}
          </ng-container>
        </small>
      </div>
    </footer>
  </div>
</div>
